import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {initializeIcons} from '@fluentui/font-icons-mdl2';
import {BrowserRouter} from "react-router-dom";

// Loading woff files from spoppe-b.azureedge.net (Microsoft CDN) was giving 400 error. Included them in the project.
initializeIcons('/fonts/');

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
